import { useState, useCallback } from 'react';

export type ViewMode = 'grid' | 'list';

type ViewModeKey = 'home' | 'folder' | 'project-files';

const STORAGE_PREFIX = 'yemma-view-mode-';

function getStored(key: ViewModeKey): ViewMode {
  const stored = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
  return stored === 'list' ? 'list' : 'grid';
}

export function useViewMode(key: ViewModeKey): [ViewMode, (mode: ViewMode) => void] {
  const [mode, setModeState] = useState<ViewMode>(() => getStored(key));

  const setMode = useCallback(
    (next: ViewMode) => {
      setModeState(next);
      localStorage.setItem(`${STORAGE_PREFIX}${key}`, next);
    },
    [key],
  );

  return [mode, setMode];
}
